module.exports = __webpack_public_path__ + "static/img/width_placeholder.2f8348a2.png";